export default __webpack_public_path__ + "static/media/checkmark.9cd3001f.svg";